import { CommonAction } from '../../../../../message/redux/types';
import TeamManagementTypes, { InvitedTeamMembersPayload, TeamData } from './types';

function fetchTeamMembers(investorUUID: string): CommonAction {
    return {
        type: TeamManagementTypes.FETCH_TEAM_MEMBERS,
        payload: investorUUID,
    };
}
function setTeamMembers(teamData: TeamData): CommonAction {
    return {
        type: TeamManagementTypes.SET_TEAM_MEMBERS,
        payload: teamData,
    };
}
function failedFetchTeamMembers(): CommonAction {
    return {
        type: TeamManagementTypes.FAILED_TEAM_MEMBERS,
        payload: undefined,
    };
}

function inviteTeamMembers(invited: InvitedTeamMembersPayload): CommonAction {
    return {
        type: TeamManagementTypes.INVITE_TEAM_MEMBERS,
        payload: invited,
    };
}

function deleteTeamMembers(investorUUID: string): CommonAction {
    return {
        type: TeamManagementTypes.INVITE_TEAM_MEMBERS,
        payload: investorUUID,
    };
}
function updateTeamRole(): CommonAction {
    return {
        type: TeamManagementTypes.UPDATE_TEAM_ROLE_MEMBERS,
        payload: undefined,
    };
}

const TeamManagementActions = {
    deleteTeamMembers,
    updateTeamRole,
    fetchTeamMembers,
    setTeamMembers,
    failedFetchTeamMembers,
    inviteTeamMembers,
};

export default TeamManagementActions;
